import { getAppStore } from '@/store';
import sendAiGenScreenActionAnalytics from '@/utils/analytics/sendAiGenScreenActionAnalytics';
import { AiGenScreenAction } from '@/types/analytics';

import type { ScreenType } from '@/types/analytics';

interface PresetLikeToggledParams {
  slug: string;
  isLiked: boolean;
  screenType: ScreenType;
}

const sendPresetLikeToggled = ({
  slug,
  isLiked,
  screenType,
}: PresetLikeToggledParams) => {
  sendAiGenScreenActionAnalytics({
    action: isLiked
      ? AiGenScreenAction.PRESET_LIKE
      : AiGenScreenAction.PRESET_UNLIKE,
    screen_type: screenType,
    settings: { category: getAppStore().activeTabSlug ?? '', id: slug },
  });
};

export default sendPresetLikeToggled;
